/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';

var NavHeader = function NavHeader(_ref) {
  var showHeader = _ref.showHeader,
    title = _ref.title;
  return showHeader ? /*#__PURE__*/React.createElement("h2", {
    className: "cpc--side-nav__header"
  }, title) : null;
};
NavHeader.propTypes = {
  /**
   * The title of the currently selected page.
   */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
   * Whether or not to display the header in the nav.
   */
  showHeader: PropTypes.bool
};
var NavHeader$1 = NavHeader;

export { NavHeader$1 as default };
